import { doc, increment, updateDoc } from "@firebase/firestore";

// Uma entrada efetiva na rota conta uma visita, inclusive quando a mesma
// compra volta à tela. A Home não faz parte do funil solicitado.
export const SCREEN_VISIT_KEYS = Object.freeze({
  "/cabine/selecione-tipo-foto": "tipo_foto",
  "/cabine/selecione-modo-captura": "modo_captura",
  "/cabine/selecione-qtd-foto": "quantidade_fotos",
  "/cabine/scan-qr-code": "qr_fotos",
  "/cabine/selfie": "selfie",
  "/cabine/aguardando-upload": "upload",
  "/cabine/editor": "editor",
  "/cabine/seleciona-pagamento": "selecao_pagamento",
  "/cabine/pagamento-em-processo": "pagamento",
  "/cabine/pagamento-sucesso": "pagamento_sucesso",
  "/cabine/pagamento-falha": "pagamento_falha",
  "/cabine/impressao": "impressao",
  "/cabine/agradecimento": "agradecimento",
});

export async function recordScreenVisit(db, path, compraId) {
  const chave = SCREEN_VISIT_KEYS[path];
  if (!chave || !compraId) return false;
  // updateDoc não cria compra fictícia. O incremento atômico impede perda
  // quando duas passagens acontecem próximas ou o cliente está offline.
  await updateDoc(doc(db, "compras", compraId), {
    [`visitas_telas.${chave}`]: increment(1),
    visitas_telas_versao: 1,
    abandono_timeout_versao: 1,
  });
  return true;
}
